import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {useValue} from "@morningtrain/react-resources";

function Link(props) {
    const {name, defaultValue} = props;

    let value = useValue(name, defaultValue);

    let label = props.label || value;

    if (React.Children.count(props.children) > 0) {
        label = props.children;
    }

    return <a href={value}
              target={props.target}
              className={props.className}
              title={props.title}
              alt={props.alt}>{label}</a>;
}

Link.defaultProps = {
    defaultValue: null,
    className: '',
    target: '_blank',
    alt: null,
    title: null,
    label: null,
}

Link.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
    className: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
    alt: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.node,
}

export default observer(Link);

